/* import __COLOCATED_TEMPLATE__ from './jury-members.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class JuryMembersComponent extends Component
{
	@service store;

	@tracked isAddingNewJuryMember = false;
	@tracked newFirstName = "";
	@tracked newLastName = "";
	@tracked newRole = "";
	@tracked newCountry = "";
	@tracked newId1 = "0";
	@tracked newId2 = "0";
	@tracked newId3 = "0";

	@tracked isCopyingFromEvent = false;
	@tracked allEvents = [];
	@tracked selectedSourceEvent = null;
	@tracked isCopying = false;
	
	@action
	async saveNew(browserEvent)
	{
		browserEvent.preventDefault();
		
		if(this.newId1 == "")
			this.newId1 = "0";
		if(this.newId2 == "")
			this.newId2 = "0";
		if(this.newId3 == "")
			this.newId3 = "0";
		
		let newJM = null
		if(this.args.classGroup)
		{
			newJM = this.store.createRecord('jury-member',
			{
				firstName: this.newFirstName,
				lastName: this.newLastName,
				role: this.newRole,
				country: this.newCountry,
				id1: this.newId1,
				id2: this.newId2,
				id3: this.newId3,
				ClassGroupId: this.args.classGroup
			});
		}
		else
		{
			newJM = this.store.createRecord('jury-member',
			{
				firstName: this.newFirstName,
				lastName: this.newLastName,
				role: this.newRole,
				country: this.newCountry,
				id1: this.newId1,
				id2: this.newId2,
				id3: this.newId3,
				EventId: this.args.event
			});
		}
		
		try
		{
			await newJM.save();
		}
		catch (error)
		{
			// Error is displayed by the adapter
			newJM.rollbackAttributes();
			return;
		}

		this.newFirstName = "";
		this.newLastName = "";
		this.newRole = "";
		this.newCountry = "";
		this.newId1 = "0";
		this.newId2 = "0";
		this.newId3 = "0";
		this.isAddingNewJuryMember = false;
	}
	
	@action
	cancelNew()
	{
		this.newFirstName = "";
		this.newLastName = "";
		this.newRole = "";
		this.newCountry = "";
		this.newId1 = "0";
		this.newId2 = "0";
		this.newId3 = "0";
		this.isAddingNewJuryMember = false;
	}
	
	@action
	async deleteJuryMember(juryMember)
	{
		juryMember.deleteRecord();
		try
		{
			juryMember.save();
		}
		catch (error)
		{
			// Error is displayed by the adapter
			juryMember.rollbackAttributes();
		}
	}

	@action
	async startCopyFromEvent()
	{
		this.allEvents = await this.store.findAll('event');
		this.isCopyingFromEvent = true;
	}

	@action
	cancelCopyFromEvent()
	{
		this.isCopyingFromEvent = false;
		this.selectedSourceEvent = null;
	}

	@action
	async selectSourceEvent(selectEvent)
	{
		const eventId = selectEvent.target.value;
		if(eventId == "-")
		{
			this.selectedSourceEvent = null;
		}
		else
		{
			this.selectedSourceEvent = await this.store.findRecord('event', eventId);
		}
	}

	@action
	async copyJuryMembers()
	{
		if(!this.selectedSourceEvent)
		{
			return;
		}

		this.isCopying = true;

		try
		{
			const sourceJuryMembers = await this.selectedSourceEvent.juryMembers;

			for(const sourceJM of sourceJuryMembers.slice())
			{
				let newJM = null;
				if(this.args.classGroup)
				{
					newJM = this.store.createRecord('jury-member',
					{
						firstName: sourceJM.firstName,
						lastName: sourceJM.lastName,
						role: sourceJM.role,
						country: sourceJM.country,
						id1: sourceJM.id1,
						id2: sourceJM.id2,
						id3: sourceJM.id3,
						ClassGroupId: this.args.classGroup
					});
				}
				else
				{
					newJM = this.store.createRecord('jury-member',
					{
						firstName: sourceJM.firstName,
						lastName: sourceJM.lastName,
						role: sourceJM.role,
						country: sourceJM.country,
						id1: sourceJM.id1,
						id2: sourceJM.id2,
						id3: sourceJM.id3,
						EventId: this.args.event
					});
				}

				await newJM.save();
			}
		}
		catch (error)
		{
			alert('Error copying jury members: ' + error.message);
		}

		this.isCopying = false;
		this.isCopyingFromEvent = false;
		this.selectedSourceEvent = null;
	}
}